import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import moment from "moment";
import { Util } from "common/util";
import { insertNewRecord } from "services/shift";
import { getMany as getDepartments } from "services/department";
import { getMany as getTeams } from "services/team";
import {
  InputText,
  Radio,
  Form,
  Button,
  Checkbox,
  Row,
  TimeInput,
  SelectInput,
  NumberInput,
} from "common/elements";

const weekendDays = [
  {
    dataIndex: [
      { name: "sunday", value: 1 },
      { name: "sunday", value: 2 },
      { name: "sunday", value: 3 },
      { name: "sunday", value: 4 },
      { name: "sunday", value: 5 },
    ],
    title: t("text_sunday"),
  },
  {
    dataIndex: [
      { name: "monday", value: 1 },
      { name: "monday", value: 2 },
      { name: "monday", value: 3 },
      { name: "monday", value: 4 },
      { name: "monday", value: 5 },
    ],
    title: t("text_monday"),
  },
  {
    dataIndex: [
      { name: "tuesday", value: 1 },
      { name: "tuesday", value: 2 },
      { name: "tuesday", value: 3 },
      { name: "tuesday", value: 4 },
      { name: "tuesday", value: 5 },
    ],
    title: t("text_tuesday"),
  },
  {
    dataIndex: [
      { name: "wednesday", value: 1 },
      { name: "wednesday", value: 2 },
      { name: "wednesday", value: 3 },
      { name: "wednesday", value: 4 },
      { name: "wednesday", value: 5 },
    ],
    title: t("text_wednesday"),
  },

  {
    dataIndex: [
      { name: "thursday", value: 1 },
      { name: "thursday", value: 2 },
      { name: "thursday", value: 3 },
      { name: "thursday", value: 4 },
      { name: "thursday", value: 5 },
    ],
    title: t("text_thursday"),
  },
  {
    dataIndex: [
      { name: "friday", value: 1 },
      { name: "friday", value: 2 },
      { name: "friday", value: 3 },
      { name: "friday", value: 4 },
      { name: "friday", value: 5 },
    ],
    title: t("text_friday"),
  },
  {
    dataIndex: [
      { name: "saturday", value: 1 },
      { name: "saturday", value: 2 },
      { name: "saturday", value: 3 },
      { name: "saturday", value: 4 },
      { name: "saturday", value: 5 },
    ],
    title: t("text_saturday"),
  },
];
export default function FormInsert() {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [applicables, setApplicables] = useState([]);
  const [isEnableShiftMargin, setIsEnableShiftMargin] = useState(true);
  const [displayEnable, setDisplayEnable] = useState("");
  const [weekendDefinition, setWeekendDefinition] = useState({
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
  });
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const timeFormat = "HH:mm";
  const clockTimeFormat = "hh:mm A";
  const util = new Util();

  const getTimeFormat = (time, format, key) => {
    if (!time && key === 1) return "";

    if (!time && key === 3) return moment("00:00", format);
    return moment(time, format);
  };

  const onChangeRadio = (e) => {
    if (e.target.value) {
      setIsEnableShiftMargin(e.target.value);
      setDisplayEnable("");
    } else {
      setIsEnableShiftMargin(e.target.value);
      setDisplayEnable("none");
    }
  };

  const handleCheckbox = (key, event, value) => {
    if (event.target.checked) {
      const foundWeekValue = weekendDefinition[key];
      const newWeekValue = [...foundWeekValue, value];
      setWeekendDefinition((preState) => {
        return { ...preState, [key]: newWeekValue };
      });
    } else {
      const foundWeekValue = weekendDefinition[key];
      const newWeekValue = foundWeekValue.filter(
        (weekValue) => weekValue !== value
      );
      setWeekendDefinition((preState) => {
        return { ...preState, [key]: newWeekValue };
      });
    }
  };

  const handleSelectApplicableFor = (value) => {
    form.setFieldsValue({
      applicables: [],
    });
    if (value === "department") {
      getDepartments({}).then((response) => {
        if (response.data) setApplicables(response.data);
      });
    } else {
      getTeams({}).then((response) => {
        if (response.data) setApplicables(response.data);
      });
    }
  };

  const handleCancel = () => {
    setLoading(false);
    setIsEnableShiftMargin(false);
    setDisplayEnable("");
    setDisabled(false);
    navigate("/setting/shift");
  };

  const onFinish = (values) => {

    values["beforeShiftStart"] = util.formatTimePicker(values.beforeShiftStart);
    values["beforeShiftEnd"] = util.formatTimePicker(values.beforeShiftEnd);
    values["workingTimeIn"] = util.formatTimePicker(values.workingTimeIn);
    values["workingTimeOut"] = util.formatTimePicker(values.workingTimeOut);
    values["endWorkingHaftDay"] = values["endWorkingHaftDay"] ? values["endWorkingHaftDay"] : false;
    values["isEnableShiftMargin"] = isEnableShiftMargin;
    values["weekendDefinition"] = JSON.stringify(weekendDefinition);
    values["applicables"] = values.applicables.map((value) => {
      return { entityId: value };
    });
    insertNewRecord(values)
      .then(() => {
        navigate("/setting/shift");
      })
      .finally(() => {
        setLoading(false);
        setDisabled(false);
        setIsEnableShiftMargin(false);
        setDisplayEnable("");
      });
  };

  return (
    <div id="shift">
      <h4>{t("text_new_shift")}</h4>
      <Form onFinish={onFinish} layout="vertical" form={form}>
        <InputText
          name="name"
          label={t("text_shift_name")}
          placeholder={t("text_shift_name")}
          requiredMessage={t("text_please_input_shift_name")}
          isAutoSelect={true}
          className="shift-name-setting"
          style={{ width: "393px", marginLeft: "10px" }}
        />
        <div className="overtime-type" style={{ marginLeft: "-10px" }}>
          <div className="time">
            <TimeInput
              name="workingTimeIn"
              label={t("text_shift_from")}
              required={true}
              errorMessage={t("text_please_select_working_time_in")}
              style={{ marginRight: "-6px" }}
              use12Hours={true}
              format={clockTimeFormat}
              placeholder={t("text_time_in")}
            />
            <TimeInput
              name="workingTimeOut"
              label={t("text_shift_to")}
              format={clockTimeFormat}
              required={true}
              use12Hours={true}
              placeholder={t("text_time_out")}
              errorMessage={t("text_please_select_working_time_out")}
            />
          </div>
        </div>

        <div className="shift-radio">
          <span>{t("text_shift_margin")}</span>
          <Radio.Group
            className="radio"
            name="isEnableShiftMargin"
            onChange={onChangeRadio}
            value={isEnableShiftMargin}
          >
            <Radio value={true}>{t("text_shift_enable")}</Radio>
            <Radio value={false}>{t("text_shift_disable")}</Radio>
          </Radio.Group>
        </div>

        <div style={{ display: `${displayEnable}`, marginLeft: "-10px" }}>
          <div className="shift-hour">
            <TimeInput
              name="beforeShiftStart"
              initialValue={getTimeFormat("00:00:00", timeFormat, 2)}
              format={timeFormat}
            />
            <span className="shift-start-span">
              {t("text_hours_before_the_shift_start")}
            </span>
          </div>

          <div className="shift-hour">
            <TimeInput
              name="beforeShiftEnd"
              initialValue={getTimeFormat("00:00:00", timeFormat, 2)}
              format={timeFormat}
            />
            <span className="shift-end-span">
              {t("text_hours_before_the_shift_end")}
            </span>
          </div>
        </div>
        <Row>
          <span
            style={{
              fontSize: "14px",
              color: "#000000",
              fontWeight: "400",
              marginLeft: "10px",
            }}
          >
            {t("text_working_hours")}
          </span>
        </Row>

        <NumberInput
          name="expectedWorkingHourPerMonth"
          label={t("text_expectedWorkingHourPerMonth")}
          required={true}
          placeholder={t("text_expectedWorkingHourPerMonth")}
          isAutoSelect={true}
          errorMessage={t("text_please_input_expectedWorkingHourPerMonth")}
          style={{ width: "393px", marginLeft: "10px" }}
        />
        <NumberInput
          name="expectedWorkingDayPerMonth"
          label={t("text_expectedWorkingDayPerMonth")}
          required={true}
          placeholder={t("text_expectedWorkingDayPerMonth")}
          isAutoSelect={true}
          errorMessage={t("text_please_input_expectedWorkingDayPerMonth")}
          style={{ width: "393px", marginLeft: "10px" }}
        />
        <Row>
          <span
            style={{
              fontSize: "14px",
              color: "#000000",
              fontWeight: "400",
              marginLeft: "10px",
            }}
          >
            {t("text_weekend_definition")}
          </span>
        </Row>

        <Row id="shift-table-checkbox">
          <table id="shift-table">
            <thead>
              <tr>
                <th rowSpan="2" style={{ width: "100px" }}>
                  {t("text_days")}
                </th>
                <th colSpan="5">{t("text_weeks")}</th>
              </tr>
              <tr>
                <th style={{ width: "35px" }}>{t("text_1st")}</th>
                <th style={{ width: "35px" }}>{t("text_2nd")}</th>
                <th style={{ width: "35px" }}>{t("text_3rd")}</th>
                <th style={{ width: "35px" }}>{t("text_4th")}</th>
                <th style={{ width: "35px" }}>{t("text_5th")}</th>
              </tr>
            </thead>
            <tbody>
              {weekendDays.map((weekendDay, index) => {
                return (
                  <tr key={index}>
                    <td className="shift-weekend">{weekendDay.title}</td>
                    {weekendDay.dataIndex.map((values, index) => {
                      return (
                        <td key={index}>
                          <Checkbox
                            onChange={(event) =>
                              handleCheckbox(values.name, event, values.value)
                            }
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Row>
        <Row>
        <Form.Item
              name="endWorkingHaftDay"
              valuePropName="checked"         
              style={{marginLeft: 10,marginTop: 15}}
            >
              <Checkbox>{t("text_enable_working_haft_day_at_weekend")}</Checkbox>
            </Form.Item>
        </Row>
        <Row>
        <SelectInput
          name="weekendDay"
          label={t("text_weekend_day")}
          style={{margin: "0 0 0 10px",width: "250px" }}
          placeholder={t("text_weekend_day")}
          valueKey="id"
          dataSource={[
            { id: "sunday", name: t("text_sunday") },
            { id: "monday", name: t("text_monday") },
            { id: "tuesday", name: t("text_tuesday") },
            { id: "wednesday", name: t("text_wednesday") },
            { id: "thursday", name: t("text_thursday") },
            { id: "friday", name: t("text_friday") },
            { id: "saturday", name: t("text_saturday") },
          ]}
        />
         </Row>
        <Row>
          <span
            style={{
              fontSize: "14px",
              color: "#000000",
              fontWeight: "400",
              marginLeft: "10px",
              marginTop: "15px",
            }}
          >
            {t("text_applicable_for")}
          </span>
        </Row>
        <SelectInput
          name="applicableFor"
          style={{ width: "157px", marginLeft: "10px" }}
          placeholder={t("text_please_select_shift")}
          errorMessage={t("text_please_select_shift_waring")}
          placement={"topLeft"}
          onSelect={handleSelectApplicableFor}
          valueKey="id"
          required={true}
          isAutoSelect={true}
          dataSource={[
            { id: "department", name: t("text_department") },
            { id: "team", name: t("text_team") },
          ]}
        />
        <SelectInput
          name="applicables"
          style={{ width: "250px", marginLeft: "10px" }}
          showArrow={true}
          mode={"multiple"}
          placement={"topLeft"}
          errorMessage={t("text_please_select_shift_waring")}
          valueKey="id"
          required={true}
          showSearch={false}
          isAutoSelect={true}
          dataSource={applicables}
        />

        <div className="ant-modal-footer2" id="btn-shift-cancel-save">
          <Button
            className="btn-cancel"
            onClick={handleCancel}
            disabled={disabled}
          >
            {t("text_cancel")}
          </Button>
          <Button
            className="btn-save"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            {t("text_save")}
          </Button>
        </div>
      </Form>
    </div>
  );
}
